
import InterchangeEventDetailDialog from '@/components/InterchangeEventDetailDialog.vue';
import TranslationHelper from '@/helpers/translation';
import Logging from '@/logging';
import gql from 'graphql-tag';
import { format } from 'date-fns';
import Vue from 'vue';

export default Vue.extend({
	components: {
		InterchangeEventDetailDialog
	},
	props: {
		item: { type: Object, required: true }
	},
	data() {
		return {
			expanded: false,
			format: format,
			interchangeEventDialogVisible: false,
			interchangeDialogActionRef: '',
			interchangeDialogInitialEventRef: ''
		};
	},
	methods: {
		async handleActionItemClick(item) {
			if (!item.action) {
				return;
			}
			Logging.log('handleActionItemClick');
			var action = await this.getAction(item.action);
			if (item.channel === 'PHONE') {
				this.$store.commit('risolto/SET_ACTION_DETAIL_DIALOG_VISIBLE', false);
				this.$store.dispatch('risolto/setActionPhoneDetailOverlayAction', action.reference);
				this.$store.dispatch('risolto/setActionPhoneDetailOverlayVisible', true);
			} else {
				this.$store.dispatch('risolto/setActionPhoneDetailOverlayVisible', false);
				this.$store.commit('actions/UPSERT_ACTION', action);
				this.$store.commit('actions/SET_SELECTED_ACTION_REF', action.reference);
				this.$store.commit('risolto/SET_SELECTED_RECIPIENT', action.recipient_by_reference);
				this.$store.commit('risolto/SET_COMPONENT_TYPE_STORE', item.channel);
				this.$store.commit('risolto/SET_ACTION_DETAIL_DIALOG_VISIBLE', true);
			}
		},
		translateEventType(channel, type) {
			return TranslationHelper.event_type(this, channel, type);
		},
		handleShowLess() {
			this.expanded = false;
		},
		handleShowAll() {
			this.expanded = true;
		},
		async getAction(ref) {
			var qry = gql`
query getAction($ref: uuid!) {
  
  risolto_action(where: { reference: { _eq: $ref } }) {
    
   status
      assignee
      assignee_by_reference {
        reference
        username
      }
      channel
      recipient
      recipient_by_reference {
        address
        balance_amount
        dunning_metadata
        last_dunning_at
        legal_id
        legal_id_type
        name
        type
        updated_by
        participant
        reference
        legal_entity
        legal_entity_by_reference {
          reference
          registration_name
        }
      }
      reference
      metadata
      message_code
      participant
      primary_invoice
      primary_invoice_by_reference {
        invoice_number
      }
      action_invoices {
        reference
        relation
        invoice_by_reference {
          invoice_number
          open_amount
          total_amount
          payment_reference
          due_date
          issue_date
          status
          recipient
          recipient_by_reference {
            reference
            name
          }
          legal_entity
          legal_entity_by_reference {
            reference
            registration_name
          }
          participant
          participant_by_reference {
            name
            reference
            logical_id
          }
          reference
          amount_currency
          interchange_links {
            interchange_by_reference {
              reference
              channel
              direction
            }
          }
        }
      }
      legal_entity
      execution_type
      source
      executed_at
      original_action
      retry_count
      start_time
      due_date
      recipient
      recipient_by_reference {
        reference
        name
        account_id
        participant
      }
      legal_entity_by_reference {
        registration_name
        outbound_channel: processing_details(path: "outbound_channel")
      }
      created_at
      assignee
      assignee_by_reference {
        username
      }
      channel_endpoint
      channel_endpoint_by_reference {
        channel
        endpoint
        endpoint_details
        deactivated_at
        deactivated_by
        last_failed_delivery_at
        last_failed_delivery_type
        locale
        priority
      }
      executed_at
      canceled_at
      updated_at
      due_date

    
  }

  
}

			`;

			var res = await this.$apollo
				.query({
					query: qry,
					variables: {
						'ref': ref
					}
				});

			if (res.data.risolto_action.length === 0) {
				return null;
			}

			var action = res.data.risolto_action[0];

			return action;
		},
		handleInvoiceClick(val) {
			Logging.log('val', val);
			this.$router.push({ name: 'invoice-detail', params: { reference: val, participant: this.selectedParticipantStore } });
		},
		normalizeInterchangeEvents(docEvents: unknown) {
			if (!docEvents) {
				return [];
			}
			return Array.isArray(docEvents) ? docEvents : [docEvents];
		},
		/** Resolve `document_interchange_event.reference` for the clicked row: validate `v_reference` against nested refs, else match by type + time (never use `interchange_event[0]` alone when multiple). */
		handleInterchangeEventClick(virtualEvent: {
			v_reference?: string;
			event_type?: string;
			last_event_timestamp?: string;
			interchange_by_reference?: { interchange_event?: unknown };
		}) {
			this.interchangeDialogActionRef = this.item.action;
			const docs = this.normalizeInterchangeEvents(virtualEvent.interchange_by_reference?.interchange_event) as Array<{
				reference?: string;
				event_type?: string;
				created_at?: string;
			}>;
			const docRefs = new Set(docs.map(d => d.reference).filter((r): r is string => Boolean(r)));

			let ref = '';
			if (virtualEvent.v_reference && docRefs.has(virtualEvent.v_reference)) {
				ref = virtualEvent.v_reference;
			} else if (docs.length === 1) {
				ref = docs[0]?.reference || '';
			} else if (docs.length > 1) {
				const wantType = virtualEvent.event_type;
				const wantTs = virtualEvent.last_event_timestamp
					? new Date(virtualEvent.last_event_timestamp).getTime()
					: NaN;
				const match = docs.find(d => {
					if (!d.reference || d.event_type !== wantType) {
						return false;
					}
					if (Number.isNaN(wantTs) || !d.created_at) {
						return false;
					}
					const t = new Date(d.created_at).getTime();
					return !Number.isNaN(t) && Math.abs(t - wantTs) < 60_000;
				});
				ref = match?.reference || virtualEvent.v_reference || '';
			} else if (virtualEvent.v_reference) {
				ref = virtualEvent.v_reference;
			}

			this.interchangeDialogInitialEventRef = ref;
			this.interchangeEventDialogVisible = true;
		}
	}
});
